import { mode } from '@chakra-ui/theme-tools';

// Focus ring color uses CSS var so it responds to color mode automatically
const focusRingLight = '0 0 0 3px var(--chakra-colors-brand-100)';
const focusRingDark = '0 0 0 3px rgba(59,130,246,0.35)';
const errorRingLight = '0 0 0 3px rgba(220,38,38,0.20)';
const errorRingDark = '0 0 0 3px rgba(220,38,38,0.35)';

export const inputStyles = {
  components: {
    Input: {
      baseStyle: {
        field: {
          fontWeight: 400,
          fontSize: 'sm',
          transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        },
      },
      variants: {
        // Default variant: used for all standard form inputs
        outline: props => ({
          field: {
            bg: mode('white', 'navy.700')(props),
            border: '1px solid',
            borderColor: mode('gray.200', 'whiteAlpha.300')(props),
            borderRadius: '8px',
            _placeholder: {
              color: mode('gray.400', 'gray.500')(props),
              fontSize: 'sm',
            },
            _hover: {
              borderColor: mode('gray.300', 'whiteAlpha.400')(props),
            },
            _focus: {
              borderColor: mode('brand.500', 'brand.400')(props),
              boxShadow: mode(focusRingLight, focusRingDark)(props),
              bg: mode('white', 'navy.700')(props),
            },
            _invalid: {
              borderColor: 'status.error',
              boxShadow: mode(errorRingLight, errorRingDark)(props),
            },
          },
        }),
        auth: props => ({
          field: {
            bg: mode('white', 'navy.700')(props),
            border: '1px solid',
            borderColor: mode('gray.200', 'whiteAlpha.300')(props),
            borderRadius: '8px',
            _placeholder: { color: mode('gray.400', 'gray.500')(props) },
            _hover: { borderColor: mode('gray.300', 'whiteAlpha.400')(props) },
            _focus: {
              borderColor: mode('brand.500', 'brand.400')(props),
              boxShadow: mode(focusRingLight, focusRingDark)(props),
            },
          },
        }),
        search: props => ({
          field: {
            border: 'none',
            py: '11px',
            borderRadius: 'inherit',
            _placeholder: { color: mode('gray.400', 'gray.500')(props) },
            _focus: { boxShadow: 'none' },
          },
        }),
        datepicker: () => ({}),
      },
      defaultProps: {
        variant: 'outline',
      },
    },
    // FormLabel: slightly heavier weight for better hierarchy
    FormLabel: {
      baseStyle: {
        fontSize: 'sm',
        fontWeight: 'medium',
        color: 'gray.700',
        mb: '6px',
      },
    },
    // Select shares Input's focus ring behaviour
    Select: {
      variants: {
        outline: props => ({
          field: {
            bg: mode('white', 'navy.700')(props),
            border: '1px solid',
            borderColor: mode('gray.200', 'whiteAlpha.300')(props),
            borderRadius: '8px',
            fontSize: 'sm',
            _hover: { borderColor: mode('gray.300', 'whiteAlpha.400')(props) },
            _focus: {
              borderColor: mode('brand.500', 'brand.400')(props),
              boxShadow: mode(focusRingLight, focusRingDark)(props),
            },
          },
        }),
      },
      defaultProps: {
        variant: 'outline',
      },
    },
    Textarea: {
      variants: {
        outline: props => ({
          bg: mode('white', 'navy.700')(props),
          border: '1px solid',
          borderColor: mode('gray.200', 'whiteAlpha.300')(props),
          borderRadius: '8px',
          fontSize: 'sm',
          _placeholder: { color: mode('gray.400', 'gray.500')(props) },
          _hover: { borderColor: mode('gray.300', 'whiteAlpha.400')(props) },
          _focus: {
            borderColor: mode('brand.500', 'brand.400')(props),
            boxShadow: mode(focusRingLight, focusRingDark)(props),
          },
        }),
      },
      defaultProps: {
        variant: 'outline',
      },
    },
  },
};
